import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const MOSS_PARAMS = [
  {
    kind: 'int',
    key: 'cells',
    label: 'Zellen',
    min: 200,
    max: 120000,
    step: 100,
    scale: 'log',
    default: 16000,
    bulkRange: [3000, 45000],
    group: 'Wachstum',
  },
  {
    kind: 'float',
    key: 'growthRate',
    label: 'Wachstumsrate',
    min: 0.05,
    max: 3,
    step: 0.05,
    default: 1,
    group: 'Wachstum',
    tooltip: 'Wie weit eine neue Zelle von ihrer Mutterzelle entfernt entsteht.',
  },
  {
    kind: 'float',
    key: 'roughness',
    label: 'Rauheit',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.55,
    group: 'Wachstum',
    tooltip: 'Streuung der Wuchsrichtung — glatt bis zottelig.',
  },
  {
    kind: 'float',
    key: 'maxThickness',
    label: 'Maximale Dicke',
    min: 2,
    max: 300,
    step: 1,
    scale: 'log',
    default: 34,
    unit: 'px',
    bulkRange: [8, 120],
    group: 'Wachstum',
    tooltip: 'Wie weit das Moos von der Kontur wegwachsen darf.',
  },
  {
    kind: 'float',
    key: 'directionBias',
    label: 'Richtungspräferenz',
    min: -1,
    max: 1,
    step: 0.01,
    default: -0.3,
    group: 'Wachstum',
    tooltip: 'Negativ lässt das Moos nach oben wachsen, positiv nach unten.',
  },
  {
    kind: 'enum',
    key: 'side',
    label: 'Seite',
    default: 'outside',
    segmented: true,
    group: 'Wachstum',
    options: [
      { value: 'outside', label: 'Aussen' },
      { value: 'inside', label: 'Innen' },
    ],
  },
  {
    kind: 'float',
    key: 'density',
    label: 'Dichte',
    min: 0.3,
    max: 6,
    step: 0.05,
    default: 1.6,
    group: 'Wachstum',
    tooltip: 'Mindestabstand zwischen Zellen, als Vielfaches der Zellgrösse.',
  },

  {
    kind: 'range',
    key: 'size',
    label: 'Zellgrösse',
    min: 0.4,
    max: 30,
    step: 0.1,
    default: [1.4, 4.2],
    unit: 'px',
    precision: 1,
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.9,
    group: 'Darstellung',
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'thickness',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'thickness', label: 'Nach Dicke' },
      { value: 'generation', label: 'Nach Generation' },
      { value: 'random', label: 'Zufällig' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'moss' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type MossValues = SchemaValues<typeof MOSS_PARAMS>;
